import {
  GET_INDUSTRIES,
  LOADING_INDUSTRIES
} from "../../actions/shared/industry";

export default (state = {}, action) => {
  switch (action.type) {
    case LOADING_INDUSTRIES:
      return {
        ...state,
        loading: true
      };
    case GET_INDUSTRIES:
      return {
        ...state,
        industries: action.industries,
        loading: false
      };
    default:
      return state;
  }
};
